module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hDqI6c/tc-custom/9781439665145.jpg?1702530412166",
      "alt": "This image is the cover for the book Haunted Florence, Haunted America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Haunted Florence, Haunted America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Florence occupies a huge space in American history, and that past left a lot of lingering spirits. A Native American \"trickster\" meanders the local swamps. In Mars Bluff, a ghostly guide offers tours of a beloved plantation. A dedicated worker in the former Jamestown area still haunts a dilapidated tobacco barn. At an abandoned boardinghouse, a spectral couple searches for a lost trinket. Author H.P. Bradley details these stories and more of the historic hauntings in the Magic City."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      H.P. Bradley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Heather lives in Florence with her young son, Daniel. She has her own website to communicate and connect with her (https://hpbradley.wixsite.com/hp-bradley). Heather is also currently developing her own curricula for a K-12 academic education program that includes the components of 1.1 tutoring, online learning, intriguing books of every kind and community-based experiential learning."), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0